<template>
    <div class="">
        <template v-if="crud_vendor === true && crud_vendor !==null">
            <form id="employeeForm" @submit.prevent="addVendorData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Vendor </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/vendors" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Vendor Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Basic Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-offset-3 col-md-6" style="margin:0 auto;">
                                <div class="form-group ntn" v-show="filer === 1">
                                    <label class="label block-label"> Enter NTN </label>
                                    <input autocomplete="off" v-model="form.ntn" type="text" name="ntn" class="form-control" :class="{ 'is-invalid': form.errors.has('ntn') }">
                                    <has-error :form="form" field="ntn"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label">Tax Filler ?</label>
                                    <label class="radio-holder ml-0 mb-0">
                                        Yes
                                        <input v-model="form.filer" type="radio" @click="filer = 1" value="1" id="btn-simsim" class="payment-transfer" name="paymentTransfer" checked="">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-holder mb-0">
                                        No
                                        <input v-model="form.filer" type="radio" @click="filer = 0" value="0" id="btn-bank" class="payment-transfer" name="paymentTransfer">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_vendor === null">
             <preLoader></preLoader>
        </template>
        <template v-else-if="crud_vendor === false">
              <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    ntn : '',
                    filer: 0,
                    vid : this.$route.params.id
                }),
                filer:0,
                crud_vendor : null
            }
        },
        methods: {
            addVendorData() {
                this.$Progress.start();
                this.form.post('/api/addVendorTaxDetail')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Vendor tax detail added successfully');
                        this.$router.push('/addVendorPaymentDetail/'+res.data.data.id);
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },

        },
        mounted() {
             this.can('crud_vendor').then(result => {
                this.crud_vendor = result.crud_vendor;
            }).then(result => {
                axios.get("/api/editVendor/" + this.$route.params.id)
                .then(res => {
                    if (res.status == 200) {
                        if(res.data.wizard_cycle == 0){
                            this.$router.push('/addVendorPersonalDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 1){
                            this.$router.push('/addVendorBasicDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 2){
                            this.form.ntn = res.data.ntn;
                            this.form.filer = res.data.tax_filler;
                            if(res.data.tax_filler === 1){
                                $('.ntn').show();
                            }
                        }else if(res.data.wizard_cycle == 3){
                            this.$router.push('/addVendorPaymentDetail/'+this.$route.params.id);
                        }
                    } else {
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            });
        }
    }
</script>
